import mapi from './mapi.js';

let gclid = mapi.urlParam("gclid");

if (typeof gclid != 'undefined' && gclid != null && gclid != "") {
    mapi.cookie("gclid", gclid, 90);
}

class xGclid {

    constructor() {
        this.df = "";
        this.p = "";
    }

    setup(df, p) {
        this.df = df;
        this.p = p;
    }

    download = async (event) => {
        event.preventDefault();

        let gclid = mapi.cookie("gclid");
        if (gclid == null) {
            gclid = "";
        }
        let link;
        link = this.df + "?filename=" + this.p + "Download.exe";
        if (gclid != "") {
            let r = await mapi.query_new({
                method: "GET",
                "path": "utils/gclid/" + gclid
            });
            let xadid = r['data']['xadid'];

            if (xadid != undefined && xadid != "") {
                link = this.df + "?filename=" + this.p + "_" + xadid + ".exe";
            }
        }

        location.href = link;
        return false;

    }
}


export default new xGclid();